module.exports = __webpack_public_path__ + "76f2253475e0d924395a938c27de31dd.pdf";